<ngx-spinner 
bdColor = "rgba(0, 0, 0, 0.8)" 
size = "medium" color = "#ee0909" 
type = "ball-atom" 
[fullScreen] = "true">
<p style="color: white" > cargando .... </p>
</ngx-spinner>

   
    <div class="panel  "  >
        
                <div class="row">
                    <div class="container">
                        <div class="col-sm-9">
                            <img src="./assets/images/Elementos/transversales.png"  class="carrucel" />
            
                        </div>
                    </div>
            <br>
                </div>
                <div class=" col-sm-12 leyenda3 "  >     
                    <p>ESTÁNDARES DE COMPETENCIA TRANSVERSALES</p>
                        </div>
                <br><br>
                <br><br>
                <br><br>
                
                <div class="row">
                    <div class="container">
                           <div class="col-sm-12  leyenda2" >
                            <p>
                                Son las relacionadas con el desarrollo personal, que no dependen de un ámbito temático o disciplinario
                                específico, sino que son aplicables a tareas y contextos diversos.

                            </p>
            <p>
                <Strong>Lo anterior de acuerdo a las siguientes fuentes: </Strong> 
            </p>
            <p>
                Podemos definir las competencias transversales como aquellas habilidades relacionadas con el desarrollo
                personal, que no dependen de un ámbito temático o disciplinario específico sino que aparecen en todos los
                dominios de la actuación profesional y académica (González y Wagenaar, 2003).</p>
            <p>
                    Una competencia transversal es una característica de la persona que entra en juego cuando responde a una
                    petición del entorno organizativo y que se considera esencial en el ámbito laboral para transformar un
                    conocimiento en comportamiento. El término se utiliza para indicar las capacidades de amplio espectro, no
                    específicas de una profesión o ambiente organizativo y es aplicable a tareas y contextos diversos.
                    El concepto es similar a lo que se denomina en el Reino Unido key skills, en Alemania Schlüsselqualifikationen y
                    en Francia compétences transversales.

                </p>
                <p>
                    Ejemplos de competencia transversal: la capacidad para diagnosticar, de relacionar, de resolver problemas, de
                    tomar decisiones, de comunicación, de organización de su trabajo, de gestión del tiempo, de adaptación a
                    diferentes entornos culturales, de manejo del estrés, de actitud ante el trabajo en equipo, espíritu de iniciativa,
                    flexibilidad y visión conjunta.
                    </p>
                    <p>
                        <a href="https://es.wikipedia.org/wiki/Competencia_transversal" target="_blank"><img src="./assets/images/icon/web.png"  class="icono" /> https://es.wikipedia.org/wiki/Competencia_transversal</a>
                    </p>
                    <p>
                        De ello se deriva la necesidad de insistir en el desarrollo de competencias generales de amplio espectro, llamadas
                        también competencias clave o transversales,
                       
                    </p>
                    <p> <a href="https://www.oitcinterfor.org/sites/default/files/file_publicacion/man_cl.pdf" target="_blank"><img src="./assets/images/icon/web.png"  class="icono" />https://www.oitcinterfor.org/sites/default/files/file_publicacion/man_cl.pdf</a> </p>
                    <p>
                        Las competencias transversales, o genéricas, son aquellas que, aunque no se requieren estrictamente para
                        realizar una actividad en concreto, ofrecen beneficios añadidos al desempeño de esa actividad o profesión,
                        independientemente de cuál sea.

                    </p>
                    <p>
                        En contraposición a estas competencias, encontramos las específicas. Estas últimas hacen referencia a aquellas
                        habilidades que sí son necesarias para la realización del trabajo en cuestión.

                    </p>
                    <p>
                        Por ejemplo, desarrollar la capacidad de trabajar en equipo es una competencia que, aunque ofrece beneficios
                        reales en prácticamente cualquier profesión, no es imprescindible para, por ejemplo, desarrollar una página web,
                        donde sí será imprescindible el dominio sobre diferentes lenguajes de programación. El conocimiento de estos
                        lenguajes sería una competencia específica.
                    </p>
                   
                        <p> <a href="https://www.euroforum.es/blog/competencias-transversales-que-son-y-por-que-las-necesitas/" target="_blank"><img src="./assets/images/icon/web.png"  class="icono" />https://www.euroforum.es/blog/https://www.euroforum.es/blog/competencias-transversales-que-son-y-por que-las-necesitas/#Que_son_las_competencias_transversales</a> </p>
                   
                    <p>
                        <a href=" https://cmapspublic3.ihmc.us/rid=1176753264062_86457339_1769/Competencias%20Transversales.pdf" target="_blank"><img src="./assets/images/icon/web.png"  class="icono" /> https://cmapspublic3.ihmc.us/rid=1176753264062_86457339_1769/Competencias%20Transversales.pdf</a>
                       
                    </p>
                           </div>
                    </div> 
                </div>
                <br>



<br>
<br>
<div class="row">
    <div class="container">
<div class="col-sm-5" ></div>
<div style="text-align: center;" class="col-sm-1" >
<button mat-button (click) = "back()"><img src="./assets/images/icon/Atras.png"  class=" imagen" /></button>
</div>
<div style="text-align: center;"  class="col-sm-1">
<button mat-button (click) = "home()"><img src="./assets/images/icon/Home.png"  class=" imagen" /></button>
</div>
</div>
</div>
</div>
